import React, { Children, lazy, Suspense, useContext, useEffect, useState } from 'react';
export const IsMobileContext = React.createContext({
  isMobile: false,
  isOpenMenuMobile: false,
  setIsOpenMenuMobile: (value: boolean) => {},
});
export default function IsMobileProvider({ children }: any) {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpenMenuMobile, setIsOpenMenuMobile] = useState(false);
  let innerWidth = window.innerWidth;
  useEffect(() => {
    setIsMobile(innerWidth <= 1024 ? true : false);
    window.addEventListener('resize', listenerScreen);
    return () => {
      window.removeEventListener('resize', listenerScreen);
    };
  }, []);
  const listenerScreen = () => {
    innerWidth = window.innerWidth;
    setIsMobile(innerWidth <= 1024 ? true : false);
  };
  return (
    <IsMobileContext.Provider value={{ isMobile, isOpenMenuMobile, setIsOpenMenuMobile }}>
      {children}
    </IsMobileContext.Provider>
  );
}
